import React from 'react'
import { Navigate } from 'react-router-dom'
import { Role } from '@wove/common/roles'
import useUserStore from '@src/state/user'
import { Alert } from '@wove/web-ui'

interface RoleRequiredProps {
  roles: Role[]
  children: React.ReactNode
  fallback?: React.ReactNode
  redirectTo?: string
}

export const RoleRequired: React.FC<RoleRequiredProps> = ({ 
  roles, 
  children, 
  fallback,
  redirectTo = '/'
}) => {
  const user = useUserStore((state) => state.user)
  const role = useUserStore((state) => state.role)
  
  if (!user) {
    return <Navigate to="/login" replace />
  }

  const userRole = role as Role
  const hasRequiredRole = role ? roles.includes(userRole) : false

  if (!hasRequiredRole) {
    if (fallback) {
      return <>{fallback}</>
    }
    
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />
    }

    return (
      <div className="p-4">
        <Alert variant="error">
          You do not have permission to access this page.
        </Alert>
      </div>
    )
  }

  return <>{children}</>
}